var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAverageBooking(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/favorite-chart"
  }, /*#__PURE__*/React.createElement("g", {
    id: "favorite-chart"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M22 13.1802V9.18018C22 4.18018 20 2.18018 15 2.18018H9C4 2.18018 2 4.18018 2 9.18018V15.1802C2 20.1802 4 22.1802 9 22.1802H13",
    stroke: "#C4D26E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.32812 14.67L9.70813 11.5799C10.0481 11.1399 10.6781 11.0599 11.1181 11.3999L12.9482 12.84C13.3882 13.18 14.0181 13.1 14.3581 12.67L16.6682 9.68994",
    stroke: "#C4D26E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M19.4812 16.0001L19.7612 16.5701C19.9012 16.8501 20.2512 17.1101 20.5612 17.1701L20.9412 17.2301C22.0812 17.4201 22.3512 18.2601 21.5312 19.0901L21.1812 19.4401C20.9512 19.6801 20.8212 20.1401 20.8912 20.4601L20.9412 20.6701C21.2512 22.0501 20.5212 22.5801 19.3212 21.8601L19.0612 21.7101C18.7512 21.5301 18.2512 21.5301 17.9412 21.7101L17.6812 21.8601C16.4712 22.5901 15.7412 22.0501 16.0612 20.6701L16.1112 20.4601C16.1812 20.1401 16.0512 19.6801 15.8212 19.4401L15.4712 19.0901C14.6512 18.2601 14.9212 17.4201 16.0612 17.2301L16.4412 17.1701C16.7412 17.1201 17.1012 16.8501 17.2412 16.5701L17.5212 16.0001C18.0612 14.9101 18.9412 14.9101 19.4812 16.0001Z",
    stroke: "#C4D26E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAverageBooking);
export default __webpack_public_path__ + "static/media/averageBooking.5a891536175d31f85e955a420a6f16f8.svg";
export { ForwardRef as ReactComponent };